/* globals jQuery */

(function($) {
  $(".icon.burger").click(function() {
    $("body").css({ overflow: "hidden" });
    $(".mobile-conatiner").css({ display: "block" });
    $(".mobile-nav-overlay")
      .css({ display: "flex" })
      .animate(
        {
          opacity: 1
        },
        300
      );
  });

  $(".mobile-nav-overlay .menu-item-has-children").append(
    '<div class="close close-black"></div>'
  );
  $(".mobile-nav-overlay .menu-item-has-children > a").click(function(e) {
    e.preventDefault();
    $(this)
      .parent("li")
      .toggleClass("open-level");
  });

  $(".mobile-nav-overlay .close").on("click", () => {
    $(".mobile-nav-overlay").animate({ opacity: 0 }, 300, () => {
      $(".mobile-conatiner").css({ display: "none" });
      $(".mobile-nav-overlay").css({ display: "none" });
      $("body").css({ overflow: "auto" });
      $(".mobile-nav-overlay .menu-item-has-children").each(function() {
        $(this).removeClass("open-level");
      });
    });
  });
})(jQuery);
